import { Component, Injector, Input, OnInit } from '@angular/core';
import { BaseModalComponent, EnumValues } from '@card-software/library';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Parameter } from '../../../models/engineering/parameter';
import { ParameterProxyService } from '../../../proxies/item/parameter.proxy.service';
import { MessageService } from 'primeng/api';
import { EnumService } from '../../../services/enum.service';
import { TranslateService } from '@ngx-translate/core';
import { LocaleHelperService } from '../../../services/localehelperservice.service';

@Component({
  selector: 'app-parameter-details-modal',
  templateUrl: './parameter-details-modal.component.html',
  styleUrl: './parameter-details-modal.component.scss',
})
export class ParameterDetailsModalComponent extends BaseModalComponent<Parameter | null> implements OnInit {
  @Input() parameter: Parameter | null = null;
  @Input() canEdit = false;
  parameterTypes: EnumValues;

  public showPascalError = false;
  public showInstructions = false;
  constructor(
    injector: Injector,
    private readonly parameterProxyService: ParameterProxyService,
    private readonly messageService: MessageService,
    private getEnumService: EnumService,
    private translateService: TranslateService,
    public localHelperService: LocaleHelperService,
  ) {
    super(injector);
    this.parameterTypes = this.getEnumService.getEnum('ParameterType', 'itemEnums').values;
  }

  ngOnInit(): void {
    this.fromGroup.patchValue({
      name: this.parameter?.name.en ?? null,
      friendlyName: this.parameter?.friendlyName.en ?? null,
      parameterType: this.parameter?.parameterType ?? null,
    });
    //Disable form by Rol
    if (!this.canEdit) {
      this.fromGroup.disable();
    }
    this._validatePascalCase();
  }

  name: FormControl<string | null> = new FormControl('', [Validators.required]);
  friendlyName: FormControl<string | null> = new FormControl('', [Validators.required]);
  parameterType: FormControl<number | null> = new FormControl(NaN, [Validators.required]);

  fromGroup: FormGroup = new FormGroup({
    name: this.name,
    friendlyName: this.friendlyName,
    parameterType: this.parameterType,
  });

  onClose() {
    this.close({ action: 'close', data: null });
  }

  onSave() {
    if (this.fromGroup.valid) {
      const parameter: Parameter = {
        id: this.parameter?.id ?? '',
        name: {
          en: this.fromGroup.value.name as string,
          es: '',
        },
        friendlyName: {
          en: this.fromGroup.value.friendlyName as string,
          es: '',
        },
        parameterType: this.fromGroup.value.parameterType,
      };

      this.parameterProxyService.upsertParameter(parameter).subscribe({
        next: (response) => {
          this.messageService.add({
            severity: 'success',
            summary: this.parameter
              ? this.translateService.instant('Parameter_Updated', {
                  name: this.localHelperService.getLocalizedValue(this.parameter.name),
                })
              : this.translateService.instant('Parameter_Created', {
                  name: this.localHelperService.getLocalizedValue(response.data?.name),
                }),
            key: 'main',
            life: 2500,
          });
          this.close({ action: 'save', data: parameter });
        },
      });
    }
  }

  private _validatePascalCase() {
    this.name.valueChanges.subscribe((data) => {
      if (data) {
        this.showPascalError = !/^[A-Z][a-zA-Z0-9]*$/.test(data);
      }
    });
  }

  _setOptionsForPrimeNg(value: EnumValues) {
    return Object.keys(value).map((key) => {
      const numKey = parseInt(key);
      return {
        label: value[numKey],
        value: numKey,
      };
    });
  }
}
